<template>
    <kgr-searchable-dropdown
        ref="dropdown"
        display="name"
        :label="label"
        :value="value"
        :options="filteredDogs"
        :loading="loading"
        :inline="inline"
        @post-input="onInput"
        @inputChanged="onInputChanged"
    />
</template>

<script>
import Dog from '../../../../js/dto/Dog.js';
import DogRepository from '../../../../js/repository/DogRepository.js';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Dog,
            required: false,
            default: () => {
                return null;
            },
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            dogs: [],
            search: '',
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('Hunde');
        },
        filteredDogs() {
            return this.dogs.filter((dog) => this.excludedIds.indexOf(dog.id) === -1);
        },
    },
    methods: {
        reload() {
            this.loading = true;
            DogRepository
                .findAll(this.clubId, null, null, null, this.search, null, 20)
                .then((data) => {
                    this.loading = false;
                    this.dogs = data;
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
        onInputChanged(input) {
            this.search = input;
            setTimeout(this.reload, 300);
        },
        resetSelected() {
            this.$refs.dropdown.selected = null;
            this.$refs.dropdown.searchFilter = '';
        },
    },
};
</script>
